
<div class="row" style="background-color: transparent;" >
    <div class="col-12 dimg" style="background-color: transparent;" >
        <div class="tcumple" >
            <div id="accordion">
                <!-- <div class="card" >
                  <div class="card-header" id="headingOne">
                    <h5 class="mb-0">
                      <button class="btn btn-link" data-toggle="collapse" [attr.data-target]="'#collapse'+ i"   aria-expanded="false"
                       >
                        {{item.fecha}}
                      </button>
                    </h5>
                  </div>

                  <div id="collapse{{i}}"  class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                    <div class="card-body">
                      Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
                    </div>
                  </div>
                </div> -->

                <div class="card" *ngFor="let item of this.cumples; let i=index">
                  <div class="card-header" id="headingThree" [ngClass]="{'today': actual(item.fecha)}">
                    <h5 class="mb-0">
                      <button class="btn btn-link " [ngClass]="{'collapsed': actual(item.fecha)}"   data-toggle="collapse" [attr.data-target]="'#collapse'+ i" [attr.data-target]="'#collapse'+ i"  [attr.aria-expanded]="actual(item.fecha)?true:false">
                        <i class="fa" aria-hidden="true" ></i> <b style="font:bold normal 18px/27px Titillium Web">{{ fecha(item.fecha)|uppercase}}</b> {{item.fechas|uppercase}}
                      </button>
                    </h5>
                  </div>
                  <div id="collapse{{i}}" class="collapse" [ngClass]="{'show': actual(item.fecha)}" aria-labelledby="headingThree" data-parent="#accordion">
                    <div class="card-body">
                      <table class="table">

                        <tbody>
                            <tr *ngFor="let item1 of item.usuarios; let i1=index">
                                <td style="width: 60%;">{{item1.perPrimerNombre}} {{item1.perSegundoNombre}} {{item1.perPrimerApellido}} {{item1.perSegundoApellido}}</td>

                                <td>{{item1.eplOrgDes4}}</td>

                                <!-- <td>{{item1.REGIONAL}}</td> -->
                            </tr>

                        </tbody>
                    </table>
                    </div>
                  </div>
                </div>
              </div>
        <!-- <table class="table">

            <tbody>
                <tr *ngFor="let item of fcumples; let i=index">
                    <td style="width: 45%;">{{item.NOMBRE}}</td>
                    <td>{{item.FECHA_NACIMIENTO | slice:0:6 }}</td>
                    <td>{{item.EMPRESA}}</td>

                    <td>{{item.REGIONAL}}</td>
                </tr>

            </tbody>
        </table> -->
    </div>
    </div>
</div>
